'use client';

import { useCallback, useContext } from 'react';
import DeferredStreamBoundary from '@/common/DeferredStreamBoundary';
import { DeferredRequestKey } from '~/constants/common/deferredRequests';
import VehicleContext from '~/context/vdp/VehicleContext';
import type { WhyBuyResult } from '~/server-props/vdp/getWhyBuy';

export default function WhyBuyDeferred({
  promise
}: {
  promise: Promise<WhyBuyResult | undefined>;
}) {
  const {
    triggerFetchWhyBuy,
    ymmtWhyBuy: { setData: setWhyBuy }
  } = useContext(VehicleContext);

  const onResolve = useCallback(
    (data: WhyBuyResult | undefined) => {
      if (data) {
        setWhyBuy(data.response);
      } else {
        triggerFetchWhyBuy();
      }
    },
    [setWhyBuy, triggerFetchWhyBuy]
  );

  return (
    <DeferredStreamBoundary
      deferredKey={DeferredRequestKey.WhyBuy}
      onResolve={onResolve}
      promise={promise}
    />
  );
}
